var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_529_6298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.2 47.8821H6.89421C3.67549 47.8821 1.04199 45.2486 1.04199 42.0299V6.91654C1.04199 3.69781 3.67549 1.06432 6.89421 1.06432H153.2C156.418 1.06432 159.052 3.69781 159.052 6.91654V42.0299C159.052 45.2486 156.418 47.8821 153.2 47.8821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2 1.06432H6.89421C3.67549 1.06432 1.04199 3.69781 1.04199 6.91654V42.0299C1.04199 45.2486 3.67549 47.8821 6.89421 47.8821H153.2C156.418 47.8821 159.052 45.2486 159.052 42.0299V6.91654C159.052 3.69781 156.418 1.06432 153.2 1.06432ZM153.2 2.00067C155.91 2.00067 158.116 4.20626 158.116 6.91654V42.0299C158.116 44.7406 155.91 46.9462 153.2 46.9462H6.89421C4.18393 46.9462 1.97835 44.7406 1.97835 42.0299V6.91654C1.97835 4.20626 4.18393 2.00067 6.89421 2.00067H153.2Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5428 13.0535C56.5428 14.0341 56.2524 14.815 55.6708 15.3975C55.0102 16.0902 54.1492 16.4368 53.0908 16.4368C52.0772 16.4368 51.2154 16.0856 50.5067 15.3824C49.7967 14.6797 49.4424 13.8083 49.4424 12.7686C49.4424 11.7284 49.7967 10.8575 50.5067 10.1543C51.2154 9.45156 52.0772 9.09995 53.0908 9.09995C53.5937 9.09995 54.0752 9.19827 54.5324 9.39444C54.9896 9.59107 55.3563 9.85208 55.6306 10.179L55.0133 10.7966C54.5484 10.2411 53.9083 9.96363 53.0908 9.96363C52.3515 9.96363 51.7123 10.2233 51.1729 10.7431C50.6333 11.2635 50.3636 11.9383 50.3636 12.7686C50.3636 13.5989 50.6333 14.2737 51.1729 14.794C51.7123 15.3138 52.3515 15.5736 53.0908 15.5736C53.875 15.5736 54.5288 15.3124 55.0522 14.7895C55.392 14.4488 55.5885 13.9752 55.641 13.367H53.0908V12.5235H56.4938C56.5267 12.7069 56.5428 12.8829 56.5428 13.0535",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5426 13.0536H56.4256C56.4246 14.0119 56.1448 14.7562 55.5879 15.3149L55.5866 15.3159L55.5861 15.3168C54.9465 15.9856 54.1244 16.3185 53.0906 16.3199C52.1041 16.3185 51.2783 15.982 50.5888 15.2998C49.9008 14.6163 49.5606 13.7819 49.5593 12.7687C49.5606 11.7551 49.9008 10.9212 50.5888 10.2381C51.2783 9.55552 52.1041 9.21855 53.0906 9.21714C53.5785 9.21714 54.043 9.3123 54.486 9.50203C54.9295 9.69316 55.2798 9.94364 55.5408 10.2546L55.6305 10.1791L55.5477 10.0964L54.9304 10.7145L55.0132 10.7968L55.1033 10.7219C54.6168 10.1389 53.9338 9.84497 53.0906 9.84673C52.324 9.84579 51.6496 10.1197 51.0917 10.6592C50.5285 11.2006 50.2455 11.9133 50.2465 12.7687C50.2455 13.6242 50.5285 14.3369 51.0917 14.8782C51.6496 15.4178 52.324 15.6917 53.0906 15.6908C53.9008 15.6922 54.5913 15.4173 55.1348 14.8724C55.4979 14.5084 55.7036 14.0041 55.7576 13.3773L55.7685 13.2501H53.2077V12.6407H56.4937V12.5236L56.3784 12.5442C56.4105 12.7217 56.4256 12.8903 56.4256 13.0536H56.5426H56.6597C56.6597 12.8757 56.6432 12.6929 56.6089 12.5027L56.5915 12.4066H52.9736V13.3672V13.4842H55.6409V13.3672L55.5243 13.3571C55.4727 13.9461 55.2852 14.3896 54.9693 14.7069C54.4664 15.2079 53.8492 15.4553 53.0906 15.4567C52.3788 15.4557 51.7748 15.2106 51.2541 14.71C50.7384 14.2112 50.4818 13.5744 50.4805 12.7687C50.4818 11.9631 50.7384 11.3263 51.2541 10.8274C51.7748 10.3268 52.3788 10.0818 53.0906 10.0808C53.8821 10.0827 54.4797 10.3442 54.9237 10.8723L55.0059 10.9701L55.7132 10.2619L55.7891 10.186L55.72 10.1041C55.4325 9.76128 55.0494 9.48915 54.5784 9.28714C54.1066 9.08453 53.6087 8.98306 53.0906 8.98306C52.0501 8.98212 51.1521 9.34788 50.4238 10.0717C49.6927 10.7941 49.3243 11.7021 49.3252 12.7687C49.3243 13.8349 49.6927 14.7434 50.4242 15.4663C51.1521 16.1896 52.0501 16.5549 53.0906 16.554C54.1742 16.5549 55.0731 16.195 55.7553 15.4786L55.6706 15.3977L55.7534 15.4804C56.3597 14.8746 56.6605 14.0562 56.6597 13.0536H56.5426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9381 10.1202H58.74V12.3469H61.6241V13.1908H58.74V15.4174H61.9381V16.2802H57.8384V9.25748H61.9381V10.1202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9375 10.1201V10.0031H58.6223V12.4638H61.5064V13.0733L58.6223 13.0736V15.5344H61.8204V16.163H57.9548V9.37443H61.8204V10.1201H61.9375V10.0031V10.1201H62.0545V9.25739V9.14034H57.7207V16.3971H62.0545V15.4173V15.3003H58.8564V13.3077H61.7405V12.3468V12.2297H58.8564V10.2372H62.0545V10.1201H61.9375",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7429 16.2802H64.8398V10.1202H62.8784V9.25748H67.7043V10.1202H65.7429V16.2802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7432 16.2801V16.163H64.9572V10.0031H62.9958V9.37443H67.5876V10.0031H65.6261V16.2801H65.7432V16.163V16.2801H65.8602V10.2372H67.8217V9.25739V9.14034H62.7617V10.1201V10.2372H64.7231V16.3971H65.7432H65.8602V16.2801H65.7432",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1963 16.2802V9.25748H72.0983V16.2802H71.1963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1961 16.2801H71.3132V9.37443H71.9812V16.163H71.1961V16.2801H71.3132H71.1961V16.3971H72.0982H72.2152V9.14034H71.1961H71.0791V16.3971H71.1961V16.2801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1011 16.2802H75.1981V10.1202H73.2368V9.25748H78.0626V10.1202H76.1011V16.2802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.101 16.2801V16.163H75.315V10.0031H73.3537V9.37443H77.9454V10.0031H75.9839V16.2801H76.101V16.163V16.2801H76.218V10.2372H78.1795V9.25739V9.14034H73.1196V10.1201V10.2372H75.0809V16.3971H76.101H76.218V16.2801H76.101",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7149 14.7845C83.2347 15.3107 83.8707 15.5736 84.6229 15.5736C85.375 15.5736 86.0114 15.3107 86.5303 14.7845C87.0506 14.2582 87.3112 13.5856 87.3112 12.7686C87.3112 11.9516 87.0506 11.279 86.5303 10.7527C86.0114 10.2265 85.375 9.96363 84.6229 9.96363C83.8707 9.96363 83.2347 10.2265 82.7149 10.7527C82.196 11.279 81.9354 11.9516 81.9354 12.7686C81.9354 13.5856 82.196 14.2582 82.7149 14.7845ZM87.1978 15.3724C86.5074 16.0824 85.6488 16.4368 84.6229 16.4368C83.5959 16.4368 82.7377 16.0824 82.0488 15.3724C81.3579 14.6632 81.0142 13.7951 81.0142 12.7686C81.0142 11.7421 81.3579 10.8739 82.0488 10.1648C82.7377 9.45472 83.5959 9.09995 84.6229 9.09995C85.6434 9.09995 86.4997 9.45659 87.1933 10.1694C87.8859 10.8822 88.2325 11.7486 88.2325 12.7686C88.2325 13.7951 87.8868 14.6632 87.1978 15.3724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7148 14.7846L82.6316 14.8669C83.1707 15.4142 83.8432 15.6922 84.6227 15.6908C85.4018 15.6922 86.0752 15.4142 86.6134 14.8669C87.156 14.3191 87.429 13.6104 87.4282 12.7687C87.429 11.9271 87.156 11.2184 86.6134 10.6706C86.0752 10.1233 85.4018 9.84532 84.6227 9.84672C83.8432 9.84532 83.1707 10.1233 82.6316 10.6706C82.0902 11.2184 81.8168 11.9271 81.8182 12.7687C81.8168 13.6104 82.0902 14.3191 82.6316 14.8669L82.7148 14.7846L82.798 14.7023C82.3015 14.197 82.0533 13.5615 82.0523 12.7687C82.0533 11.976 82.3015 11.3404 82.798 10.8352C83.2991 10.33 83.8975 10.0822 84.6227 10.0808C85.3474 10.0822 85.9472 10.33 86.447 10.8352C86.9444 11.3404 87.1927 11.976 87.1936 12.7687C87.1927 13.5615 86.9444 14.197 86.447 14.7023C85.9472 15.2075 85.3474 15.4553 84.6227 15.4567C83.8975 15.4553 83.2991 15.2075 82.798 14.7023L82.7148 14.7846ZM87.1977 15.3725L87.114 15.2912C86.4429 15.9788 85.6222 16.3185 84.6227 16.3199C83.6228 16.3185 82.8021 15.9788 82.1323 15.2912L82.1291 15.2875L82.1323 15.2912C81.4625 14.6012 81.132 13.7691 81.1311 12.7687C81.132 11.7684 81.4625 10.9363 82.1323 10.2463C82.8021 9.55868 83.6228 9.21855 84.6227 9.21714C85.6157 9.21855 86.4346 9.56008 87.1095 10.2513C87.7815 10.9445 88.1139 11.7753 88.1153 12.7687C88.1139 13.7691 87.7825 14.6012 87.114 15.2912L87.1977 15.3725L87.2819 15.4539C87.9914 14.7251 88.3502 13.8212 88.3494 12.7687C88.3502 11.7222 87.99 10.8202 87.2772 10.0882C86.564 9.35338 85.6706 8.98177 84.6227 8.98305C83.5693 8.98177 82.6732 9.35162 81.9645 10.0836V10.0832C81.2536 10.8123 80.896 11.7163 80.897 12.7687C80.896 13.8212 81.2536 14.7251 81.9645 15.4543L81.9677 15.4576L81.9645 15.4539C82.6732 16.1859 83.5693 16.5549 84.6227 16.554C85.6757 16.5549 86.5718 16.1859 87.2819 15.4539L87.1977 15.3725",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.499 16.2802V9.25748H90.5973L94.0103 14.7207H94.0491L94.0103 13.3673V9.25748H94.9133V16.2802H93.9714L90.4006 10.5522H90.3618L90.4006 11.9061V16.2802H89.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4989 16.2801H89.6159V9.37443H90.5321L93.9452 14.8376H94.049H94.1692L94.1272 13.3654V9.37443H94.7961V16.163H94.0362L90.4654 10.4351H90.3616H90.2414L90.2834 11.9079V16.163H89.4989V16.2801H89.6159H89.4989V16.3971H90.4005H90.5175V11.9041L90.4787 10.549L90.3616 10.5521V10.6692H90.4005V10.5521L90.3012 10.6144L93.9063 16.3971H94.9131H95.0302V9.14034H94.0101H93.8931V13.3686L93.9319 14.7237L94.049 14.7205V14.6035H94.0101V14.7205L94.1094 14.6584L90.6619 9.14034H89.4989H89.3818V16.3971H89.4989V16.2801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.205 36.1776H128.389V21.5457H126.205V36.1776ZM145.877 26.8164L143.373 33.1601H143.298L140.7 26.8164H138.347L142.244 35.6829L140.022 40.6148H142.301L148.305 26.8164H145.877ZM133.491 34.5157C132.775 34.5157 131.778 34.1582 131.778 33.2731C131.778 32.1437 133.021 31.7108 134.093 31.7108C135.054 31.7108 135.504 31.9178 136.088 32.2005C135.919 33.5556 134.752 34.5157 133.491 34.5157V34.5157ZM133.754 26.4963C132.173 26.4963 130.536 27.1931 129.858 28.7367L131.796 29.5459C132.211 28.7367 132.982 28.4728 133.792 28.4728C134.921 28.4728 136.07 29.1509 136.088 30.3556V30.506C135.693 30.2801 134.846 29.9414 133.811 29.9414C131.721 29.9414 129.594 31.0894 129.594 33.2355C129.594 35.1933 131.307 36.4547 133.227 36.4547C134.695 36.4547 135.504 35.7958 136.013 35.0242H136.088V36.1534H138.196V30.5435C138.196 27.9461 136.258 26.4963 133.754 26.4963V26.4963ZM120.257 28.5976H117.151V23.5821H120.257C121.89 23.5821 122.817 24.934 122.817 26.0898C122.817 27.2237 121.89 28.5976 120.257 28.5976ZM120.201 21.5457H114.968V36.1776H117.151V30.6341H120.201C122.621 30.6341 125.001 28.8816 125.001 26.0898C125.001 23.2982 122.621 21.5457 120.201 21.5457ZM91.6641 34.5184C90.1553 34.5184 88.892 33.2552 88.892 31.5201C88.892 29.7668 90.1553 28.4843 91.6641 28.4843C93.1537 28.4843 94.3228 29.7668 94.3228 31.5201C94.3228 33.2552 93.1537 34.5184 91.6641 34.5184V34.5184ZM94.1719 27.6357H94.0964C93.6063 27.0513 92.6631 26.5233 91.4753 26.5233C88.9862 26.5233 86.7048 28.7106 86.7048 31.5201C86.7048 34.3109 88.9862 36.4794 91.4753 36.4794C92.6631 36.4794 93.6063 35.9513 94.0964 35.3483H94.1719V36.0647C94.1719 37.9695 93.1537 38.9876 91.5132 38.9876C90.1745 38.9876 89.3447 38.0257 89.005 37.215L87.1008 38.0069C87.6476 39.3268 89.0997 40.9486 91.5132 40.9486C94.0777 40.9486 96.2462 39.4398 96.2462 35.763V26.8251H94.1719V27.6357ZM97.7545 36.1776H99.9418V21.5452H97.7545V36.1776ZM103.166 31.3505C103.11 29.427 104.656 28.4467 105.768 28.4467C106.636 28.4467 107.371 28.8802 107.616 29.503L103.166 31.3505ZM109.955 29.6913C109.54 28.5784 108.276 26.5233 105.693 26.5233C103.128 26.5233 100.998 28.541 100.998 31.5014C100.998 34.2922 103.11 36.4794 105.938 36.4794C108.22 36.4794 109.54 35.084 110.087 34.2733L108.39 33.1417C107.824 33.9716 107.051 34.5184 105.938 34.5184C104.826 34.5184 104.034 34.0092 103.524 33.0101L110.181 30.2568L109.955 29.6913ZM56.9239 28.0508V30.1626H61.9773C61.8264 31.3505 61.4305 32.2178 60.827 32.8213C60.0918 33.5569 58.9415 34.3676 56.9239 34.3676C53.8125 34.3676 51.3802 31.8598 51.3802 28.7485C51.3802 25.6372 53.8125 23.1291 56.9239 23.1291C58.6022 23.1291 59.8275 23.7892 60.7328 24.6378L62.2224 23.1483C60.9591 21.9412 59.2807 21.0172 56.9239 21.0172C52.6622 21.0172 49.0796 24.4869 49.0796 28.7485C49.0796 33.0101 52.6622 36.4794 56.9239 36.4794C59.2245 36.4794 60.9591 35.7255 62.3166 34.3109C63.712 32.9155 64.1459 30.9545 64.1459 29.3708C64.1459 28.8802 64.1083 28.428 64.0325 28.0508H56.9239ZM69.8911 34.5184C68.3823 34.5184 67.0811 33.2739 67.0811 31.5014C67.0811 29.71 68.3823 28.4843 69.8911 28.4843C71.3994 28.4843 72.7006 29.71 72.7006 31.5014C72.7006 33.2739 71.3994 34.5184 69.8911 34.5184V34.5184ZM69.8911 26.5233C67.1378 26.5233 64.8938 28.6163 64.8938 31.5014C64.8938 34.3676 67.1378 36.4794 69.8911 36.4794C72.6439 36.4794 74.8879 34.3676 74.8879 31.5014C74.8879 28.6163 72.6439 26.5233 69.8911 26.5233ZM80.7917 34.5184C79.2835 34.5184 77.9822 33.2739 77.9822 31.5014C77.9822 29.71 79.2835 28.4843 80.7917 28.4843C82.3001 28.4843 83.6013 29.71 83.6013 31.5014C83.6013 33.2739 82.3001 34.5184 80.7917 34.5184ZM80.7917 26.5233C78.0385 26.5233 75.795 28.6163 75.795 31.5014C75.795 34.3676 78.0385 36.4794 80.7917 36.4794C83.5446 36.4794 85.7886 34.3676 85.7886 31.5014C85.7886 28.6163 83.5446 26.5233 80.7917 26.5233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.343 38.9744L13.256 38.8911C12.9154 38.5308 12.7144 37.9712 12.7144 37.2466V37.4171V11.5316C12.7144 11.5292 12.7144 11.5275 12.7144 11.5256C12.7144 11.5278 12.7144 11.5297 12.7144 11.532V11.703C12.7144 10.9184 12.9488 10.3273 13.3416 9.97287L27.8432 24.4741L13.343 38.9744ZM12.7144 11.5242C12.7144 11.4597 12.7161 11.3971 12.7194 11.3354C12.7161 11.3966 12.7144 11.4597 12.7144 11.5242ZM12.7194 11.3326C12.7194 11.3318 12.7194 11.3308 12.7197 11.3299C12.7194 11.3308 12.7194 11.3318 12.7194 11.3326ZM12.7197 11.3244C12.7197 11.3239 12.7197 11.3234 12.7197 11.323C12.7197 11.3234 12.7197 11.3239 12.7197 11.3244Z",
    fill: "url(#paint0_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6769 29.4808L32.7871 29.4182L38.514 26.1643C39.06 25.8539 39.4239 25.4776 39.6054 25.0794C39.4244 25.4776 39.0604 25.8543 38.514 26.1647L32.7871 29.4187L32.6769 29.4808V29.4808ZM32.6783 29.3094L27.8438 24.474L32.6778 19.6395L38.514 22.9551C39.2551 23.3763 39.6712 23.919 39.7407 24.4736C39.7407 24.474 39.7407 24.475 39.7407 24.4758C39.6712 25.0291 39.2551 25.5723 38.514 25.9933L32.6783 29.3094",
    fill: "url(#paint1_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.377 39.5266C13.9719 39.5266 13.6184 39.3949 13.3428 39.1462L13.3433 39.1457C13.6189 39.3945 13.9728 39.5266 14.3779 39.5266C14.413 39.5266 14.4487 39.5257 14.4849 39.5239C14.4483 39.5257 14.4121 39.5266 14.377 39.5266V39.5266ZM14.3775 39.3551C13.9724 39.3556 13.6189 39.2235 13.3433 38.9747V38.9744L27.8434 24.4741L32.6779 29.3095L15.6887 38.9625C15.2187 39.229 14.7733 39.3551 14.3775 39.3551V39.3551ZM13.3392 39.1431C13.3135 39.1198 13.2884 39.0951 13.2637 39.0694L13.3392 39.1431Z",
    fill: "url(#paint2_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8434 24.474L13.3418 9.97278C13.6174 9.72453 13.9704 9.59286 14.3751 9.59286C14.772 9.59286 15.2177 9.7195 15.6887 9.98648L32.6774 19.6395L27.8434 24.474V24.474ZM32.7867 19.5303L15.6887 9.81559C15.2177 9.5485 14.772 9.42186 14.3751 9.42186C14.3732 9.42186 14.3719 9.42186 14.37 9.42186C14.3724 9.42186 14.3741 9.42186 14.3769 9.42186C14.7729 9.42186 15.2181 9.54803 15.6887 9.81512L32.7867 19.5303V19.5303Z",
    fill: "url(#paint3_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.485 39.5239C14.853 39.5029 15.2604 39.3762 15.6888 39.1335L32.6766 29.4809L15.6888 39.1335C15.2607 39.3767 14.853 39.5029 14.485 39.5239V39.5239ZM13.3428 39.1462L13.3392 39.1431C13.3405 39.144 13.3419 39.1453 13.3428 39.1462ZM13.2637 39.0694L13.2563 39.0622V39.0617C13.2592 39.0644 13.2614 39.0671 13.2637 39.0694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6763 29.4808L32.7865 29.4182L32.6763 29.4808Z",
    fill: "url(#paint4_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.378 39.5266C13.9729 39.5266 13.619 39.3945 13.3433 39.1457L13.3428 39.1462C13.3419 39.1453 13.3405 39.144 13.3392 39.1431L13.2637 39.0694C13.2614 39.0671 13.2592 39.0644 13.2563 39.0617L13.3433 38.9747C13.619 39.2235 13.9724 39.3556 14.3775 39.3551C14.7734 39.3551 15.2187 39.229 15.6888 38.9625L32.678 29.3095L32.7868 29.4183L32.6766 29.4809L15.6888 39.1335C15.2604 39.3762 14.853 39.5029 14.485 39.5239C14.4488 39.5257 14.4131 39.5266 14.378 39.5266",
    fill: "url(#paint5_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.256 39.0623C12.9154 38.7019 12.7144 38.1423 12.7144 37.4177V37.4172C12.7144 38.1423 12.9154 38.7014 13.256 39.0618V39.0623",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.256 39.0618C12.9154 38.7014 12.7144 38.1423 12.7144 37.4172V37.2466C12.7144 37.9713 12.9154 38.5309 13.256 38.8912L13.343 38.9745L13.256 39.0618",
    fill: "url(#paint6_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2563 39.0618L13.3433 38.9745V38.9748L13.2563 39.0618",
    fill: "url(#paint7_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6055 25.0795C39.6955 24.8819 39.7408 24.6789 39.7408 24.4759C39.7408 24.4755 39.7408 24.4751 39.7408 24.4751C39.7408 24.6785 39.6955 24.8814 39.6055 25.0795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7871 29.4182L32.6782 29.3094L38.5139 25.9933C39.2551 25.5722 39.6712 25.029 39.7407 24.4758C39.7407 24.6788 39.6954 24.8818 39.6054 25.0794C39.4238 25.4776 39.06 25.8539 38.5139 26.1643L32.7871 29.4182Z",
    fill: "url(#paint8_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7407 24.474V24.4735C39.7402 23.8613 39.331 23.2491 38.514 22.7846L32.7871 19.5306H32.7866L32.7871 19.5303L38.514 22.7841C39.332 23.2487 39.7416 23.8617 39.7407 24.474Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7407 24.4736C39.6711 23.9191 39.255 23.3763 38.5139 22.9552L32.6777 19.6396L32.7866 19.5307H32.7871L38.5139 22.7847C39.331 23.2492 39.7402 23.8614 39.7407 24.4736Z",
    fill: "url(#paint9_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7144 11.5256C12.7144 11.5252 12.7144 11.5247 12.7144 11.5242C12.7144 11.5247 12.7144 11.5252 12.7144 11.5256ZM12.7194 11.3354C12.7194 11.3345 12.7194 11.3336 12.7194 11.3326C12.7194 11.3336 12.7194 11.3345 12.7194 11.3354ZM12.7197 11.3299C12.7197 11.3281 12.7197 11.3263 12.7197 11.3244C12.7197 11.3263 12.7197 11.3281 12.7197 11.3299ZM12.7197 11.323C12.7875 10.1206 13.4413 9.42609 14.3662 9.422C13.9652 9.42434 13.6159 9.55601 13.3425 9.80239V9.80192L13.3393 9.8052C13.3105 9.83118 13.2831 9.85869 13.256 9.88701C12.9488 10.212 12.755 10.699 12.7197 11.323Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7144 11.703V11.532C12.7144 11.5297 12.7144 11.5278 12.7144 11.5256C12.7144 11.5251 12.7144 11.5246 12.7144 11.5242C12.7144 11.4597 12.7161 11.3966 12.7194 11.3354C12.7194 11.3344 12.7194 11.3335 12.7194 11.3326C12.7194 11.3317 12.7194 11.3308 12.7197 11.3299C12.7197 11.328 12.7197 11.3262 12.7197 11.3244C12.7197 11.3239 12.7197 11.3234 12.7197 11.323C12.755 10.6989 12.9488 10.212 13.256 9.88694L13.3416 9.97285C12.9488 10.3273 12.7144 10.9183 12.7144 11.703V11.703ZM13.3393 9.80513L13.3425 9.80185C13.3416 9.80326 13.3402 9.80419 13.3393 9.80513Z",
    fill: "url(#paint10_linear_529_6298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6775 19.6395L15.6888 9.98652C15.2178 9.71954 14.7721 9.5929 14.3752 9.5929C13.9706 9.5929 13.6175 9.72458 13.3419 9.97283L13.2563 9.88692C13.2834 9.85859 13.3108 9.83108 13.3396 9.8051C13.3405 9.80416 13.3419 9.80323 13.3428 9.80229C13.6163 9.55591 13.9655 9.42424 14.3665 9.4219C14.3675 9.4219 14.3687 9.4219 14.3701 9.4219C14.372 9.4219 14.3733 9.4219 14.3752 9.4219C14.7721 9.4219 15.2178 9.54854 15.6888 9.81563L32.7868 19.5303L32.7864 19.5307L32.6775 19.6395Z",
    fill: "url(#paint11_linear_529_6298)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_529_6298",
    x1: 26.5573,
    y1: 11.2585,
    x2: 6.91434,
    y2: 30.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_529_6298",
    x1: 40.6437,
    y1: 24.4747,
    x2: 12.3225,
    y2: 24.4747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_529_6298",
    x1: 30.1007,
    y1: 27.1606,
    x2: 3.46342,
    y2: 53.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_529_6298",
    x1: 9.58315,
    y1: 1.27042,
    x2: 21.4778,
    y2: 13.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_529_6298",
    x1: 40.6432,
    y1: 24.475,
    x2: 12.3216,
    y2: 24.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_529_6298",
    x1: 30.1008,
    y1: 27.1606,
    x2: 3.46348,
    y2: 53.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_529_6298",
    x1: 26.5574,
    y1: 11.2585,
    x2: 6.91436,
    y2: 30.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_529_6298",
    x1: 30.1014,
    y1: 27.1607,
    x2: 3.46417,
    y2: 53.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_529_6298",
    x1: 40.6437,
    y1: 24.4747,
    x2: 12.3224,
    y2: 24.4747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_529_6298",
    x1: 40.6437,
    y1: 24.4748,
    x2: 12.3224,
    y2: 24.4748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_529_6298",
    x1: 26.5573,
    y1: 11.2585,
    x2: 6.91435,
    y2: 30.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_529_6298",
    x1: 9.58326,
    y1: 1.27046,
    x2: 21.4779,
    y2: 13.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_6298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.361,
    height: 47.0518,
    fill: "white",
    transform: "translate(0.925293 0.947266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d41b5b8bbadca20c50aa956864ab8cf9.svg";
export { ForwardRef as ReactComponent };